import { isRejectedWithValue } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { decryptUserId, encryptUserId } from "../utilis/encrypto";
// import BASE_URL from "../common";
import { BASE_URL } from "../constant";
// const base_url = "https://pstgs.appsndevs.com/chatrap";

export function Selectedllm(user) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    axios
      .post(`${BASE_URL}/chatbot/llm_selection`, user, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // toast.success(response.data.message);
          // console.log(response.data.message,"asdhfg")
          resolve(response.data);
        }
        if (response.data.status !== "success") {
          // toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        console.log("error", error);
        toast.error("Network error. Please check your connection.");
        reject(error);
      });
  });
}

export function ModelSelected(user) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }
    axios
      .get(`${BASE_URL}/chatbot/model_list/${decryptedUserId}`, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // toast.success(response.data.message);
          // console.log(response.data.message,"asdhfg")
          resolve(response.data);
        }
        // console.log(response.data);
        resolve(response.data);

        if (response.data.status !== "success") {
          // toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        console.log("error", error);
        toast.error("Network error. Please check your connection.");
        reject(error);
      });
  });
}

export function SendQuery(payload) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    axios
      .post(`${BASE_URL}/chatbot/chatbot_llm`, payload, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          resolve(response.data); // Resolve on success
        } else {
          if (response.data.message === "Not enough tokens.") {
            toast.error(response.data.message);

            reject({
              status_code: response.data.status_code || 400,
              message: response.data.message,
            });
          } else {
            const error = {
              status_code: response.data.status_code || 400, // Default status code to 400 if not provided

              less_amount: response.data.less_amount || false, // Add other error data as needed
            };

            reject(error);
          }
        }
      })
      .catch(function (error) {
        toast.error("Network error. Please check your connection.");
        reject({
          status_code: 500,
          message: "Network error. Please check your connection.",
          error,
        }); // Reject with network error details
      });
  });
}
export function ModelSelection(payload) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    axios
      .post(`${BASE_URL}/chatbot/model_selection`, payload, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // toast.success(response.data.message);
          resolve(response.data);
        } else {
          // toast.error(response.data.message);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        toast.error("Network error. Please check your connection.");
        reject(error);
      });
  });
}

export function Chathistory() {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .get(`${BASE_URL}/chatbot/chat_history/${decryptedUserId}`, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}
export function ClearChat() {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .post(`${BASE_URL}/chatbot/clear_chat/${decryptedUserId}`, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          resolve(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}
export function Lasthistory(payload) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      // console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .post(`${BASE_URL}/chatbot/latest_chat_history`, payload, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}
export function Chatlike(payload) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      // console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .post(`${BASE_URL}/chatbot/like_dislike_the_message`, payload, {
        headers,
      })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response);
        } else {
          console.log(response);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}

export function Connetionhistory(payload) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      // console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .post(`${BASE_URL}/chatbot/connection_with_history`, payload, { headers })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          console.log(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}

export function BalanceReminder() {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    const encryptedUserId = localStorage.getItem("userId");
    const decryptedUserId = decryptUserId(encryptedUserId);

    if (!decryptedUserId) {
      console.error("Failed to decrypt user ID.");
      return reject(new Error("Failed to decrypt user ID."));
    }

    axios
      .get(`${BASE_URL}/chatbot/balance_reminder/${decryptedUserId}`, {
        headers,
      })
      .then(function (response) {
        if (response.data.status === "success") {
          // console.log(response.data.message, "asdhfg");
          resolve(response.data);
        } else {
          resolve(response.data);
        }
      })
      .catch(function (error) {
        // console.log("error", error);
        reject(error);
      });
  });
}

const Chatapiservices = {
  Selectedllm,
  ModelSelected,
  Chathistory,
  SendQuery,
  ClearChat,
  Lasthistory,
  Connetionhistory,
  ModelSelection,
  Chatlike,
  BalanceReminder,
};

export default Chatapiservices;
